import {
  OPEN_INTERACTIVITY_STUDIO,
  CLOSE_INTERACTIVITY_STUDIO,
  SET_INTERACTIVITY_STUDIO_TAB,
  SET_INTERACTIVITY_STUDIO_BUSY,
  SELECT_INTERACTIVE_ITEM,
  SET_INTERACTIVE_MODE,
  SELECT_SCENE,
  SELECT_SCENARIO_ELEMENT,
} from "../common/actions";

const initialState = {
  open: false,
  tab: null,
  busy: null,
  mode: null,
  // Legacy item selection (kept for backward compat with existing consumers)
  selectedBoxId: null,
  selectedItemId: null,
  // Scenario-system selection
  selectedSceneId: null,
  selectedElementId: null,
};

export default function interactivityStudio(state = initialState, action) {
  switch (action.type) {
    case OPEN_INTERACTIVITY_STUDIO:
      return { ...state, open: true, tab: action.payload.tab };
    case CLOSE_INTERACTIVITY_STUDIO:
      return initialState;
    case SET_INTERACTIVITY_STUDIO_TAB:
      return { ...state, tab: action.payload.tab };
    case SET_INTERACTIVITY_STUDIO_BUSY:
      return { ...state, busy: action.payload.busy };
    case SELECT_INTERACTIVE_ITEM:
      return {
        ...state,
        selectedBoxId: action.payload.boxId,
        selectedItemId: action.payload.itemId,
      };
    case SET_INTERACTIVE_MODE:
      return { ...state, mode: action.payload.mode };
    case SELECT_SCENE:
      return {
        ...state,
        selectedBoxId: action.payload.boxId,
        selectedSceneId: action.payload.sceneId,
        selectedElementId: null,
      };
    case SELECT_SCENARIO_ELEMENT:
      return {
        ...state,
        selectedBoxId: action.payload.boxId,
        selectedSceneId: action.payload.sceneId,
        selectedElementId: action.payload.elementId,
      };
    default:
      return state;
  }
}
